import api from '../../plugins/api';
import { checkError, cloneDeep, parseAddressToApp, prepareApiParams } from 'erp-skeleton-library/utils';

const template =  {
  id: 0,
  name: null,
  type: 1,
  addresses: [
    {
      address: {
        zipCode: null,
        city: null,
        state: null,
        address: null,
        number: null,
      },
    },
  ],
};

const state = {
  tableLoading: false,
  allPlaces: [],
  registerPlace: cloneDeep(template),
  headers: [
    {
      text: 'Nome',
      align: 'left',
      value: 'name',
    },
    {
      text: 'Cidade',
      align: 'left',
      value: 'address.city.name',
    },
  ],
  placesTypes: [
    {
      id: 1,
      label: 'PRÓPRIA'
    },
    {
      id: 2,
      label: 'CONTRATANTE'
    },
    {
      id: 3,
      label: 'ALUGADA'
    }
  ]
};

const mutations = {
  LIST(state, payload) {
    state.allPlaces = payload;
    state.tableLoading = false;
  },
  SET(state, payload) {
    if (!!payload) {
      payload.addresses = parseAddressToApp(payload);
      state.registerPlace = payload;
    } else {
      state.registerPlace = cloneDeep(template);
    }
  },
};

const actions = {
  create({ commit }, payload) {
    return new Promise((resolve, reject) => {
      api.post('places', payload)
           .then(response => {
              resolve(response.data);;
           }).catch(error => {
        checkError(error.response.status);
        reject(error.response);
      });
    });
  },
  list({ commit }, payload) {
    state.tableLoading = true;
    let query = prepareApiParams(payload, 'id, name, address, createdBy');

    return new Promise((resolve, reject) => {
      api
        .get('places?' + new URLSearchParams(query).toString())
        .then(response => {
          commit('LIST', response.data.entities);
          state.tableLoading = false;
          resolve(response.data);
        })
        .catch(error => {
          state.tableLoading = false;
          checkError(error.response.status);
          reject(error.response);
        });
    });
  },
  read({ commit }, id) {
    return new Promise((resolve, reject) => {
      api.get('places/' + id)
           .then(response => {
             commit('SET', response.data);
              resolve(response.data);;
           }).catch(error => {
        checkError(error.response.status);
        reject(error.response);
      });
    });
  },
  update({ commit }, payload) {
    return new Promise((resolve, reject) => {
      api.put('places/' + payload.id, payload).then(response => {
         resolve(response.data);;
      }).catch(error => {
        checkError(error.response.status);
        reject(error.response);
      });
    });
  },
  delete({ commit }, id) {
    return new Promise((resolve, reject) => {
      api.delete('places/' + id)
           .then((response) => {
              resolve(response.data);;
           })
           .catch((error) => {
             checkError(error.response.status);
             reject(error.response);
           });
    });
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
